import { isNullOrWhitespace } from "../../../common/stringOperations";
import { SelectableItem } from "../../../processingActivity/ProcessingActivity.types.ts";

export interface ControlRowViewModel {
    id: string;
    customId: string;
    name: string;
    description?: string;
    annualWheelActivities: Array<FrameworkControlAnnualWheelActivityViewModel>;
    category: SelectableItem;
    categoryCustomId?: string;
    annualWheelActivityPlanningStatus: PlanningStatus;
    note: string;
    isSelected: boolean;
    groupEntityIds: Array<string>;
    implementationGroup: string | undefined;
}

export interface FrameworkControlAnnualWheelActivityViewModel {
    name: string;
    isPlanned: boolean;
}

export interface ControlRowViewModelTableModel extends ControlRowViewModel {
    responsible: string | undefined;
    responsibleString: string;
    deadline: Date | null;
    deadlineString: string;
    categoryString: string;
    note: string;
    noteRequired: boolean;
}

export class controlModel {
    controlId: string;
    responsible?: string;
    deadline: Date | null;
    isSelected: boolean;
    note?: string;
    groupEntityIds: Array<string>;

    constructor(controlId: string, isSelected: boolean, groupEntityIds: Array<string>, deadline: Date | null, responsible?: string, note?: string) {
        this.controlId = controlId;
        this.isSelected = isSelected;
        this.responsible = responsible;
        this.deadline = deadline;
        this.note = note;
        this.groupEntityIds = groupEntityIds;
    }

    withUpdates(updates: Partial<controlModel>): controlModel {
        return new controlModel(
            (updates.controlId = this.controlId),
            updates.isSelected! ?? this.isSelected,
            updates.groupEntityIds ?? this.groupEntityIds,
            updates.deadline ?? this.deadline,
            updates.responsible ?? this.responsible,
            updates.note ?? this.note
        );
    }

    isFormInvalid() {
        return this.responsibleInvalid() || this.deadlineInvalid() || this.noteIsInvalid();
    }

    responsibleInvalid() {
        return this.isSelected && isNullOrWhitespace(this.responsible ?? null);
    }

    deadlineInvalid() {
        return this.isSelected && this.deadline === null;
    }

    noteIsInvalid() {
        return !this.isSelected && isNullOrWhitespace(this.note ?? null);
    }
}

export enum PlanningStatus {
    None = 1,
    Partial = 2,
    Complete = 3,
}
